// @vendors
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// @actions
import { resetData } from "actions/okWizard";
import cardNGODetailsActions from "actions/contactCenter/cardNGODetails";
import {
    requestSolidarityCard,
    resetSolidarityOperation
} from "actions/okWizardSolidarity";

// @components
import CardMoreOptionsButton from "components/cards/cardMoreOptionsButton/cardMoreOptionsButton";

// @common-components
import { OKCover } from "commonsComponents/OKCover";
import { OKHeaderSubPage } from "commonsComponents/OKHeaderSubPage";
import { WizardSpain } from "./wizards/wizardSpain/wizardSpain";
import { WizardPassport } from "./wizards/wizardPassport/wizardPassport";

// @utils
import { i18n } from "core/i18n";
const { formatText } = i18n;
import apiURLBuilder from "core/apiURLBuilder";
import CardHeaderDetails from "components/cards/cardHeaderDetails/cardHeaderDetails";
import { getFormattedString } from "utilities/currencyHelper";

// @api
import { APIPost, APIGet } from "utilities/APIRequestHelper";

// @constants
import { LIMIT_CHARITY_AMOUNT, DEFAULT_COUNTRY } from "constants/index";

let generateAmounts = (amounts, currency) =>
    amounts.map(amount => ({
        value: amount === "INFINITE" ? LIMIT_CHARITY_AMOUNT : amount,
        label:
            amount === "INFINITE"
                ? formatText("ngoAmounts-maxLimit")
                : getFormattedString({ amount, currency })
    }));

export class CardNGODetailsView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            maxAmount: {
                value: 0,
                label: ""
            },
            minAmount: {
                value: 0,
                label: ""
            },
            charityFoundations: [],
            charityFoundationsError: false,
            modifyCharity: true,
            precontractualUrl: ""
        };
    }

    componentWillMount = async () => {
        const {
            immCardsById,
            match: { params: { cardId } },
            setInfoSuccess,
            setInfoFailure,
            originCountry
        } = this.props;

        const baseURL = apiURLBuilder.getURL("solidarity");

        const dataOngVersion = {
            header: {
                version: 2
            }
        };

        try {
            const result = await APIGet(() => { },
                `${baseURL}/ngos?solidarityCorner=true&solidarityCard=true&country=${originCountry}`, dataOngVersion);
            this.setState({
                charityFoundationsSource: [
                    ...result.map(({ ngoId, name }) => ({ ngoId, name }))
                ]
            });
        } catch (error) {
            this.setState({
                charityFoundationsSourceError: true
            });
        }

        if (!Boolean(this.props.currentStep) > 0) {
            try {
                const result = await APIGet(() => { },
                    `${baseURL}/ngo-cards/${immCardsById.get(cardId).getIn(["contract", "number"])}`);
                this.setState(
                    {
                        maxAmount: generateAmounts(
                            [result.maxAmount],
                            "EUR"
                        )[0],
                        minAmount: generateAmounts(
                            [result.minAmount],
                            "EUR"
                        )[0],
                        charityFoundations: [
                            ...result.ngos.map(ngo => ({ suggestion: ngo }))
                        ]
                    },
                    __CONTACT_CENTER__ ? setInfoSuccess : undefined
                );
            } catch (error) {
                if (!error.error.status === 400) {
                    this.setState(
                        {
                            charityFoundationsError: true
                        },
                        __CONTACT_CENTER__ ? setInfoFailure : undefined
                    );
                }
            }
        }
    };

    componentDidMount() {
        const {
            immCardsById,
            match: { params: { cardId } },
            requestSolidarityCard
        } = this.props;
        const data = immCardsById.get(cardId).getIn(["contract", "number"]);
        requestSolidarityCard(data);
    }

    componentWillUnmount() {
        const { localResetData, resetSolidarityOperation } = this.props;
        localResetData();
        resetSolidarityOperation();
    }

    submitResults = async (
        localSetWizardSuccess,
        localSetWizardError,
        dataToken
    ) => {
        const baseURL = apiURLBuilder.getURL("solidarity");
        const {
            immCardsById,
            match: { params: { cardId } },
            minAmount,
            maxAmount,
            charityFoundations
        } = this.props;

        try {
            if (!this.props.newNGOCard) {
                await APIPost(
                    () => { },
                    `${baseURL}/ngo-cards/${immCardsById
                        .get(cardId)
                        .getIn(["contract", "number"])}`,
                    {
                        query: {
                            firma: {
                                dataToken
                            },
                            minAmount,
                            maxAmount,
                            ngos: charityFoundations.map(cf =>
                                cf.getIn(["suggestion", "ngoId"])
                            )
                        }
                    }
                );
            } else {
                await APIPost(
                    () => { },
                    `${baseURL}/ngo-existent-card`,
                    {
                        query: {
                            firma: {
                                dataToken
                            },
                            minAmount,
                            maxAmount,
                            ngos: charityFoundations.map(cf =>
                                cf.getIn(["suggestion", "ngoId"])
                            ),
                            contract: immCardsById.get(cardId).getIn(["contract", "number"]),
                            pan: immCardsById.get(cardId).get('number').replace(/\s/g, "")
                        }
                    }
                );
            }
            localSetWizardSuccess();
        } catch (error) {
            localSetWizardError();
        }
    };

    buildWizards = () => {
        const {
            originCountry,
            immCardsById,
            immAccounts,
            match: { params: { cardId } }
        } = this.props;

        let modifyCharity = this.props.currentStep <= 0;
        const immCard = immCardsById.get(cardId);
        const fullContractNumber = immCardsById.getIn([
            cardId,
            "fullContractNumber"
        ]);
        const beneficiaryName = immCardsById.getIn([cardId, "beneficiaryName"]);
        let cardAccount;

        immAccounts.get("byId").map(account => {
            if (
                account.get("iban").substr(account.get("iban").length - 7) ===
                immCard.get("associatedAccountShort")
            ) {
                cardAccount = account.get("accountId");
            }
        });

        if (originCountry === DEFAULT_COUNTRY) {
            return (
                <WizardSpain
                    propsWizard={{ ...this.props }}
                    charityFoundationsError={this.state.charityFoundationsError}
                    submitResults={this.submitResults}
                    cardAccount={cardAccount}
                    modifyCharity={modifyCharity}
                    minAmountStateValue={this.state.minAmount.value}
                    maxAmountStateValue={this.state.maxAmount.value}
                    charityFoundations={this.state.charityFoundations}
                    immCard={immCardsById.get(cardId)}
                    fullContractNumber={fullContractNumber}
                    beneficiaryName={beneficiaryName}
                />
            );
        } else {
            return (
                <WizardPassport
                    propsWizard={{ ...this.props }}
                    immCardById={immCardsById}
                    cardId={cardId}
                    submitResults={this.submitResults}
                    cardAccount={cardAccount}
                    immCard={immCardsById.get(cardId)}
                    fullContractNumber={fullContractNumber}
                    beneficiaryName={beneficiaryName}
                />
            );
        }
    };

    render() {
        const {
            immCardsById,
            match: { params: { cardId } },
            flagBasedFeatures,
            immScreen,
            immCancelCardPayLater
        } = this.props;

        const immCard = immCardsById.get(cardId);

        const type = immCard.get("type");
        const subtitleLeft = formatText(`cards-${type}`);

        const cardMoreOptionsButton = (
            <CardMoreOptionsButton
                cardId={cardId}
                flagBasedFeatures={flagBasedFeatures}
                immCard={immCard}
                immCancelCardPayLater={
                    __CONTACT_CENTER__ ? immCancelCardPayLater : undefined
                }
            />
        );

        let cardMoreOptionsButtonMobile;
        let cardMoreOptionsButtonDesktop;

        if (immScreen.get("isMobile")) {
            cardMoreOptionsButtonMobile = cardMoreOptionsButton;
        } else {
            cardMoreOptionsButtonDesktop = cardMoreOptionsButton;
        }

        return (
            <div>
                <div className="container-fluid card-ngo-details--header-identifier">
                    <div className="row">
                        <OKCover
                            size="medium"
                            section="cards"
                            customClass="col-xs-12"
                        >
                            <OKHeaderSubPage
                                breadcrumbConfig={[
                                    {
                                        text: formatText("breadcrumb-cards"),
                                        url: "/myprofile/cards"
                                    },
                                    {
                                        text: formatText(
                                            "modifySolidarityCard-breadcrumbSolidarityCard"
                                        ),
                                        url: `/myprofile/cards/${cardId}/movements`
                                    },
                                    {
                                        text: formatText(
                                            "modifySolidarityCard-breadcrumbSolidarityCardOperation"
                                        )
                                    }
                                ]}
                                finalTitle={formatText(
                                    "modifySolidarityCard-pageTitle"
                                )}
                                subtitleLeft={subtitleLeft}
                            >
                                <div>
                                    {cardMoreOptionsButtonMobile}
                                    <CardHeaderDetails
                                        immCard={immCard}
                                        rightSpace={true}
                                    />
                                    {cardMoreOptionsButtonDesktop}
                                </div>
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">{this.buildWizards()}</div>
            </div>
        );
    }
}

CardNGODetailsView.propTypes = {
    charityFoundations: PropTypes.array.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    immCardsById: PropTypes.object.isRequired,
    maxAmount: PropTypes.number.isRequired,
    minAmount: PropTypes.number.isRequired,
    match: PropTypes.object.isRequired,
    setInfoSuccess: PropTypes.func.isRequired,
    setInfoFailure: PropTypes.func.isRequired,
    localResetData: PropTypes.func,
    currentStep: PropTypes.number,
    immAccounts: PropTypes.object,
    immScreen: PropTypes.object.isRequired,
    immCancelCardPayLater: PropTypes.object.isRequired,
    originCountry: PropTypes.string
};

module.exports.CardNGODetailsView = connect(
    state => ({
        currentStep: state.okWizard.get("currentStep"),
        typeChange: state.okWizard.get("typeChange"),
        accountId: state.okWizard.getIn(["steps", 2, "accountId"]),
        charityFoundations: state.okWizard.getIn([
            "steps",
            0,
            "charityFoundations"
        ]),
        error: state.okWizard.get("error"),
        immCardsById: state.cards.get("byId"),
        maxAmount: state.okWizard.getIn(["steps", 0, "maxAmount"]),
        minAmount: state.okWizard.getIn(["steps", 0, "minAmount"]),
        newNGOCard: state.okWizardSolidarity.get("newNGOCard"),
        submitSuccessful: state.okWizard.get("submitSuccessful"),
        flagBasedFeatures: state.flagBasedFeatures,
        allwizard: state.okWizard,
        immAccounts: state.accounts,
        immScreen: state.screen,
        immCancelCardPayLater: state.cancelCardPayLater,
        originCountry: state.profile.get("originCountry")
    }),
    {
        localResetData: resetData,
        requestSolidarityCard,
        resetSolidarityOperation,
        setInfoFailure: cardNGODetailsActions.setInfoFailure,
        setInfoSuccess: cardNGODetailsActions.setInfoSuccess
    }
)(CardNGODetailsView);
